// Disables, shows spinner and shows done state for submit buttons on AJAX requests
// Also disables and shows spinner for standard HTTP requests
// HTML at: app/views/shared/_form_submit_button.html.haml
compiler('[form-submit-button]', (button) => {
  const form = button.closest("form");
  if (form === null) {
    return
  }
  const isRemote = form.hasAttribute("data-remote");
  const textSpan = button.querySelector('span.ready');
  const spinnerSpan = button.querySelector('span.loading');
  const doneSpan = button.querySelector('span.done');

  if (textSpan === null || spinnerSpan === null || doneSpan === null) {
    return
  }
  if (isRemote) {
    addRemoteEventListeners();
  } else {
    addStandardEventListeners();
  }

  function showSpan(span) {
    span.classList.remove('im-hidden');
    span.classList.add('im-visible');
  }

  function hideSpan(span) {
    span.classList.remove('im-visible');
    span.classList.add('im-hidden');
  }

  function handleFormSubmit() {
    button.disabled = true;

    // Only show the spinner after specified time
    // This means it won't be shown with faster response times.
    // But the button will always be disabled
    return setTimeout(function () {
      // Hide the text
      hideSpan(textSpan);

      // Show the spinner
      showSpan(spinnerSpan);
    }, 200);
  }

  function addStandardEventListeners() {
    // No on-complete handling logic needed as page will reload on standard request
    form.addEventListener('submit', handleFormSubmit);
  }

  function addRemoteEventListeners() {
    let timeoutId = null;

    $(form).on('ajax:before', function (ev) {
      timeoutId = handleFormSubmit();
    });

    $(form).on('ajax:complete', function (ev) {
      clearTimeout(timeoutId);

      // Show the 'done' span
      button.style.width = button.offsetWidth + 'px';
      hideSpan(textSpan);
      hideSpan(spinnerSpan);
      showSpan(doneSpan);

      // Hide the 'done' span again and restore the regular button
      setTimeout(function() {
        button.disabled = false;
        // Unset the width, so that the content sets it again
        button.style.width = '';

        hideSpan(doneSpan)
        showSpan(textSpan);
      }, 2000);
    });
  }
});
